import { render, staticRenderFns } from "./userPassword2.vue?vue&type=template&id=27adc4ec&"
import script from "./userPassword2.vue?vue&type=script&lang=js&"
export * from "./userPassword2.vue?vue&type=script&lang=js&"
import style0 from "./userPassword2.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports